import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleConsigli() {
  return <ArticleLayout article={articleContents['itaobuy-consigli-avanzati']} />;
}